import { action } from '@ember/object';
import { didCancel } from 'ember-concurrency';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import AwayMessageSection from '../away-message-section.gjs';
import BaseRoute from './base-route.gjs';
import Component from '@glimmer/component';
import ConversationListItem from '../conversation-list-item.gjs';
import SharedInfinityLoader from 'ember-simplepractice/components/shared/infinity-loader';
import styles from './conversation-list.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class MessagingRoutesConversationList extends Component {
  @service alertManager;
  @service intl;
  @service messaging;
  @service messagingNavigation;

  get headerText() {
    return this.intl.t('emc.navigation.conversation_list', {
      amount: this.messaging?.currentProfile?.unreadConversationIds?.length || 0,
    });
  }

  @action
  async loadMoreConversations(model) {
    try {
      await this.messaging.loadMoreConversations.perform(model);
    } catch (err) {
      if (didCancel(err)) return;
      this.alertManager.broadcast('toast', {
        message: this.intl.t('emc.general_error'),
        type: 'error',
      });
    }
  }

  @action
  navigateToContactsPage() {
    this.messagingNavigation.toContacts();
  }

  <template>
    <BaseRoute class="{{styles.component}} conversation-list-page" data-test-conversation-list-page>
      <:header>
        <div class="navigation-bar" data-test-navigation-bar>
          {{svgJar "messaging-locked" class="locked-icon"}}
          <h3 class="navigation-text" data-test-header>{{this.headerText}}</h3>
          {{#if this.messaging.currentProfile.isClinician}}
            <button
              class="button transparent new-button"
              type="button"
              data-test-conversation-list-page-new-button
              {{on "click" this.navigateToContactsPage}}
            >
              {{svgJar "messaging-compose"}}
            </button>
          {{/if}}
        </div>
      </:header>
      <:default>
        {{#if this.messaging.currentProfile.isClinician}}
          <AwayMessageSection />
        {{/if}}

        {{#if this.messaging.getConversations.isRunning}}
          <div class="spinner" data-test-loading-spinner>
            {{svgJar "messaging-spinner"}}
          </div>
        {{else if this.messaging.conversations}}
          <ul class="conversation-list-body" data-test-conversation-list-body>
            {{#each this.messaging.sortedConversations as |conversation|}}
              <ConversationListItem @conversation={{conversation}} />
            {{/each}}

            <SharedInfinityLoader
              @model={{this.messaging.conversations}}
              @infinityLoad={{this.loadMoreConversations}}
            />
          </ul>
        {{else}}
          <div class="empty-conversation-list" data-test-empty-conversation-list>
            {{svgJar "messaging-welcome"}}
            <h3 class="empty-list-header" data-test-empty-header>{{t "emc.empty_list_header"}}</h3>
            <p class="empty-list-text" data-test-empty-text>{{t "emc.empty_list_text"}}</p>
            {{#if this.messaging.currentProfile.isClinician}}
              <button
                class="button primary create-message-button"
                type="button"
                data-test-empty-list-create-message-button
                {{on "click" this.navigateToContactsPage}}
              >
                Create Message
              </button>
            {{/if}}
          </div>
        {{/if}}
      </:default>
    </BaseRoute>
  </template>
}
